import { DynamicConfig } from '@/config/config';
import { createTheme, PaletteMode } from '@mui/material';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    status_new: true;
    status_tooEarly: true;
    status_live: true;
    status_tooLate: true;
    status_closed: true;
  }
}

declare module '@mui/material/Radio' {
  interface RadioPropsColorOverrides {
    status_new: true;
    status_tooEarly: true;
    status_live: true;
    status_tooLate: true;
    status_closed: true;
  }
}

export const useViatelTheme = (config: DynamicConfig, mode?: PaletteMode) => {
  const getColor = (environment: 'DEV' | 'TEST' | 'STAGE' | 'PROD'): { primary: string; secondary: string } => {
    switch (environment) {
      case 'TEST':
        return { primary: '#e5ad06', secondary: '#55717b' };
      case 'STAGE':
        return { primary: '#2196f3', secondary: '#dacf1d' };
      case 'PROD':
        return { primary: '#c04', secondary: '#00aacc' };
      case 'DEV':
      default:
        return { primary: '#ae2854', secondary: '#9ad0ff' };
    }
  };

  const colors = getColor(config.environment);

  return createTheme({
    palette: {
      primary: {
        main: colors.primary
      },
      secondary: {
        main: colors.secondary
      },
      ...(mode && { mode: mode })
    },
    typography: {
      fontSize: 12,
      // Viatel Admin has html font size 10px inherited from bootstrap.
      // adjust MUI to compensate correctly.
      ...(document.title.includes('Viatel Admin') && {
        htmlFontSize: 10
      })
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableElevation: true
        }
      },
      MuiCardHeader: {
        defaultProps: {
          titleTypographyProps: {
            fontSize: '1rem',
            fontWeight: 700
          }
        }
      }
    }
  });
};
